/**
 * 根据屏幕宽度设置视口缩放策略
 * 屏幕宽度大于600px不允许缩放，小于等于600px允许缩放
 */
export function setViewportByScreenWidth(): void {
  let viewportContent = "viewport-fit=cover, user-scalable=yes";

  let viewportMeta = document.querySelector('meta[name="viewport"]');

  if (viewportMeta) {
    viewportMeta.setAttribute("content", viewportContent);
  } else {
    viewportMeta = document.createElement("meta");
    (viewportMeta as any).name = "viewport";
    (viewportMeta as any).content = viewportContent;
    document.head.appendChild(viewportMeta);
  }
}

export function useMobileUserTipModal() {
  const screenWidth = window.innerWidth || document.documentElement.clientWidth;
  // 根据屏幕宽度设置视口缩放策略
  if (screenWidth < 600) {
    setViewportByScreenWidth();
  }
}
